import { darken, getValue } from "../utils.js";

export const INPUT = {
  "Input.Bg.Color": {
    ref: "Color.White"
  },
  "Input.Focus.Bg.Color": {
    ref: "Color.White"
  },
  "Input.Readonly.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Input.Disabled.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Input.Error.Bg.Color": {
    ref: "Color.White"
  },
  "Input.Border.Top.Left.Radius": {
    defaultValue: "4px"
  },
  "Input.Border.Top.Right.Radius": {
    defaultValue: "4px"
  },
  "Input.Border.Bottom.Right.Radius": {
    defaultValue: "4px"
  },
  "Input.Border.Bottom.Left.Radius": {
    defaultValue: "4px"
  },
  "Input.Border.Color": {
    ref: "Color.Gray.300",
    referredIn: ["Input.Hover.Border.Color"]
  },
  "Input.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Input.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Input.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Input.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Input.Hover.Border.Color": {
    valueFunc: (meta) => {
      return darken(getValue("Input.Border.Color", meta), 0.5);
    }
  },
  "Input.Focus.Border.Color": {
    ref: "Color.Primary.500"
  },
  "Input.Focus.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Input.Focus.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Input.Focus.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Input.Focus.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Input.Readonly.Border.Color": {
    defaultValue: "transparent"
  },
  "Input.Readonly.Border.Left.Width": {
    defaultValue: "0"
  },
  "Input.Readonly.Border.Right.Width": {
    defaultValue: "0"
  },
  "Input.Readonly.Border.Top.Width": {
    defaultValue: "0"
  },
  "Input.Readonly.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Input.Disabled.Border.Color": {
    defaultValue: "transparent"
  },
  "Input.Disabled.Border.Left.Width": {
    defaultValue: "0"
  },
  "Input.Disabled.Border.Right.Width": {
    defaultValue: "0"
  },
  "Input.Disabled.Border.Top.Width": {
    defaultValue: "0"
  },
  "Input.Disabled.Border.Bottom.Width": {
    defaultValue: "0"
  },
  "Input.Error.Border.Color": {
    ref: "Color.Error.500"
  },
  "Input.Error.Border.Left.Width": {
    defaultValue: "1px"
  },
  "Input.Error.Border.Right.Width": {
    defaultValue: "1px"
  },
  "Input.Error.Border.Top.Width": {
    defaultValue: "1px"
  },
  "Input.Error.Border.Bottom.Width": {
    defaultValue: "1px"
  },
  "Input.Font.Size": {
    ref: "Font.Size.14"
  },
  "Input.Color": {
    ref: "Color.Gray.900"
  },
  "Input.Error.Color": {
    ref: "Color.Gray.900"
  },
  "Input.Disabled.Color": {
    ref: "Color.Gray.300"
  },
  "Input.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Input.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Input.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Input.Padding.Top": {
    defaultValue: "7px"
  },
  "Input.Padding.Right": {
    defaultValue: "8px"
  },
  "Input.Padding.Bottom": {
    defaultValue: "7px"
  },
  "Input.Padding.Left": {
    defaultValue: "8px"
  },
  "Input.Label.Text.Size": {
    ref: "Font.Size.12"
  },
  "Input.Label.Text.Color": {
    ref: "Color.Gray.700"
  },
  "Input.Label.Text.Gap": {
    ref: "Space.4"
  },
  "Input.Help.Text.Size": {
    ref: "Font.Size.12"
  },
  "Input.Help.Text.Color": {
    ref: "Color.Gray.400"
  },
  "Input.Help.Text.Gap": {
    ref: "Space.4"
  },
  "Input.Error.Text.Color": {
    ref: "Color.Error.500"
  },
  "Input.Placeholder.Color": {
    ref: "Color.Gray.300"
  },
  "Input.Shadow": {
    defaultValue: "none"
  },
  "Input.Focus.Shadow": {
    defaultValue: "none"
  },
  "Input.Icon.Color": {
    ref: "Color.Icon.Dark.Gray"
  },
  "Input.Disabled.Icon.Color": {
    ref: "Color.Icon.Disabled"
  },
  "Input.Icon.Size": {
    defaultValue: "12px"
  }
};
